import Investor from '../../../models/Investor';

export function statusLabel(s: Investor['status']): string {
  return (
    (
      {
        CANDIDATE: 'Candidate',
        LEAD: 'Lead',
        OPPORTUNITY: 'Opportunity',
        COMMITTED_INVESTOR: 'Investor',
      } as const
    )[s] ?? s
  );
}

export function statusColor(s: Investor['status']): 'default' | 'info' | 'warning' | 'success' {
  return (
    (
      {
        CANDIDATE: 'default',
        LEAD: 'info',
        OPPORTUNITY: 'warning',
        COMMITTED_INVESTOR: 'success',
      } as const
    )[s] ?? 'default'
  );
}
